if (!customElements.get('rone-sticky-cta')) {
  customElements.define(
    'rone-sticky-cta',
    class RoneStickyCta extends HTMLElement {
      connectedCallback() {
        this.days = this.querySelector('[data-sticky-days]');
        this.pct = this.querySelector('[data-sticky-pct]');
        this.msrp = this.querySelector('[data-sticky-msrp]');
        this.total = this.querySelector('[data-sticky-total]');

        document.addEventListener('rone:tier-select', (event) => this.updateFromTier(event.detail));

        const triggerSelector = this.dataset.showAfter;
        const trigger = triggerSelector ? document.querySelector(triggerSelector) : null;
        if (!trigger) {
          this.classList.add('rone-sticky-cta--show');
          return;
        }

        const observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('rone-sticky-cta--show', entry.boundingClientRect.top < 0);
            document.body.classList.toggle('rone-sticky-cta-shown', entry.boundingClientRect.top < 0);
          },
          { threshold: 0 }
        );
        observer.observe(trigger);
      }

      updateFromTier(detail) {
        if (this.days) this.days.textContent = detail.days;
        if (this.pct) this.pct.textContent = detail.pct;
        if (this.msrp) this.msrp.textContent = '$' + detail.msrpTotal.toFixed(2);
        if (this.total) this.total.textContent = '$' + detail.total.toFixed(2);
      }
    }
  );
}
